import { lazy } from "react";

// Lazy load analytics and tracking components
export const LazyPerformanceTracker = lazy(() => 
  import("@/components/PerformanceTracker").then(module => ({
    default: module.PerformanceTracker
  }))
);

export const LazyEmailAnalytics = lazy(() => 
  import("@/components/EmailAnalytics")
);

export const LazySMSAlertsManagement = lazy(() => 
  import("@/components/SMSAlertsManagement").then(module => ({
    default: module.SMSAlertsManagement
  }))
);